<template>
    <playerList :type="'AC_AIM'"></playerList>
</template>

<script>
    import playerList from "../../components/newPlayerList";
    export default {
        name: "AC_AIM",
        components:{
            playerList
        }
    }
</script>
